import SlimSelect from 'slim-select';

class FormField {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-formfield'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$formField = $element;

        this.initialize();
    }

    initialize () {
        this.initField(this.$formField);
    }

    initField ($element) {
        const formType = $element.getAttribute(this.settings.initAttr); // eslint-disable-line

        switch (formType) {
        case 'select': {
            const $field = $element.querySelector('select');
            let closeOnSelect = false;
            let allowDeselect = true;

            if ($field.getAttribute('multiple') === null) {
                closeOnSelect = true;
                allowDeselect = false;
            }

            if ($field.getAttribute('placeholder') && !$field.querySelector('[data-placeholder]')) {
                const $placeholder = $field.firstChild;
                $placeholder.setAttribute('data-placeholder', true);
            }

            if ($field.length <= 1) {
                $field.classList.add('form-select--no-options');
                // $field.setAttribute('disabled', true);
            } else {
                $field.classList.remove('form-select--no-options');
            }

            const fieldAPI = new SlimSelect({
                select: $field,
                settings: {
                    allowDeselect,
                    closeOnSelect,
                    showSearch: false,
                    placeholderText: $field.getAttribute('placeholder'),
                    contentLocation: $element
                },
                events: {
                    afterChange: (newValue) => {
                        console.log(newValue);
                        $field.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            $element.fieldAPI = fieldAPI;
            break;
        }
        }
    }
}

export { FormField };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$formField = $context.querySelectorAll('[data-formfield]');
        for (let i = 0; i < $$formField.length; i++) {
            const $formField = $$formField[i];

            const formFieldAPI = new FormField($formField);
            $formField.API = formFieldAPI;
        }
    }
});

window.addEventListener('form:init', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$formField = $context.querySelectorAll('[data-formfield]');
        for (let i = 0; i < $$formField.length; i++) {
            const $formField = $$formField[i];

            const formFieldAPI = new FormField($formField);
            $formField.API = formFieldAPI;
        }
    }
});
